import { Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import "firebase/firestore";
import _ from "lodash";
import * as React from "react";
import { useEffect, useState } from "react";
import { getOrders, nbfModificationTotalQuantity, nbfOrderTotalQuantity, nbfTotalReturn } from "../../api/restApi";
import OverlayLoader from "../../components/modals/OverlayLoader";
import { ordersData } from "../../store/reducer/ordersSlice";
import { productsData } from "../../store/reducer/productsSlice";
import { ConvertOrderArrayToObject } from "../../utils/helpers";
import { useAppSelector } from "../../utils/hooks";
import useMediaQuery from '@material-ui/core/useMediaQuery';


export default function DashboardOrders() {
  const [category, setCategory] = useState([]);
  const isMediumScreen = useMediaQuery('(min-width: 960px)'); 
  const [orderByCustomer, setOrderByCustomer] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [productsInfo, setProductsInfo] = useState([]);
  const { products } = useAppSelector(productsData);
  const [openLoader, setOpenLoader] = useState(false);
  const [orderPlaced,setOrderPlaced]=useState()
  const [orderProduced, setOrderProduced] = useState();
  const [orderReturn, setOrderReturn] = useState("");

  const { ordersDate } = useAppSelector(ordersData);
  const sortedOrdersDate = [...ordersDate].sort(
    (a, b) => new Date(b) - new Date(a)
  );

  const [selectedDate, setSelectedDate] = useState(sortedOrdersDate[0]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    flexGrow: 1,
  }));

  async function callData(date) {
    
    try {
      setCategory([]);
      setOrderByCustomer([]);
      setProductsInfo([]);
      let data = await getOrders(date);
      data = ConvertOrderArrayToObject(data);
      let orderType = [];
      let products = _.sortBy(data.orders_product, "id");
      products = products.map((pro) => {
        return {
          ...pro,
          ...findProduct(pro.id),
        };
      });

      const groups = _.groupBy(products, "category_english");
      Object.entries(groups).map(([key, value]) => {
        orderType.push(key);
      });
      setCategory([...orderType]);
      setOrderByCustomer([...data.orders_customer]);
      setProductsInfo(groups);
      if (orderType.length > 0) {
        setSelectedCategory("All");
      }
      
    } catch {
      setOpenLoader(false);
    }
  }

  

  const findProduct = (id) => {
    return products.find((el) => el.id.toString() === id.toString());
  };
  const handleSelectDate = async (event, newValue) => {
    setSelectedDate(newValue);
    callData(newValue);
  };

  const handleSelectCagegory = async (event, newValue) => {
    setSelectedCategory(newValue);
  };

  const totalOrder = async () => {
    setOpenLoader(true);
    try{
console.log(selectedDate,selectedCategory)
      const totalOrderPlaced = await nbfOrderTotalQuantity(
        selectedDate,
        selectedCategory
      );
      
      const totalOrderProduced = await nbfModificationTotalQuantity(
        selectedDate,
        selectedCategory
      );
      
      setOrderProduced(totalOrderProduced);
      setOrderPlaced(totalOrderPlaced);
      setOpenLoader(false);
      const totalReturn = await nbfTotalReturn(selectedDate, selectedCategory);
      setOrderReturn(totalReturn);
    }
  
    catch{
      setOpenLoader(false);
    }
  };

  useEffect(()=>{
      callData(sortedOrdersDate[0])
      totalOrder()
  },[])

  useEffect(() => {
    if (selectedDate) {
      totalOrder();
    }
  }, [selectedDate, selectedCategory]);

  return (
    <div>
    <Stack alignItems="center" spacing={1} marginTop="0rem">
    <Box sx={{ flexGrow: 0 }}>
      <Grid item xs={24} md={6}>
      <Card 
          alignItems='start'
                sx={{
                  width: "100%", 
                  marginTop: "0rem",
                  "@media (min-width: 300px)": {
                                width: 350, // Set the width to 100% for mobile view
                  },
                  "@media (min-width: 650px)": {
                                width: 650, // Set the width to 650px for screens wider than 650px
                  },
          }}
        >
    <CardContent>
    <Stack alignItems="center" spacing={2} justifyContent="center">
      <label style={{ minWidth: isMediumScreen ? '400px' : '300px' ,display:'flex',flexDirection:'row'}}>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={sortedOrdersDate}
          sx={{
            minWidth: isMediumScreen ? '300px' : '150px',
            display: "flex",
            justifyContent: "center",
            padding:1,
          }}
          value={selectedDate}
          onChange={handleSelectDate}
          renderInput={(params) => (
            <TextField {...params} label="Select a date" />
          )}
        />

        <Autocomplete
          disablePortal
          id="combo-box-demo2"
          options={["All", ...category]}
          sx={{
            minWidth: isMediumScreen ? '300px' : '150px',
            display: "flex",
            justifyContent: "center",
            padding:1
          }}
          value={selectedCategory}
          onChange={handleSelectCagegory}
          renderInput={(params) => (
            <TextField {...params} label="Select Category" />
          )}
        />
        </label>
      </Stack>

      <Typography
        align="center"
        style={{ fontSize: "25px", marginTop: "0.5rem", fontWeight: "bold" }}
      >
        Daily Orders report
      </Typography>

      {selectedDate && selectedCategory && (
        <Stack alignItems="center">
          <Stack
            sx={{ background: "#f5f5f5", padding: "1rem",minWidth: isMediumScreen ? '600px' : '320px' }}
          >
            <Stack direction="row" justifyContent="space-between">
              <Typography>Total Order Placed</Typography>
              <Typography>{orderPlaced?.totalQuantity}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography>Total Order Produced</Typography>
              <Typography>{orderProduced?.totalQuantity}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography>DIFF</Typography>
              <Typography>
                {orderPlaced
                  ? orderPlaced?.totalQuantity - orderProduced?.totalQuantity
                  : ""}
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <Typography>Total Return</Typography>
              <Typography>{orderReturn?.totalReturn}</Typography>
            </Stack>
          </Stack>
        </Stack>
      )}
      <OverlayLoader open={openLoader} />
      </CardContent>
        </Card>
      </Grid>
      </Box>
      </Stack>
    </div>
  );
}
